export default function EmployeesReportAvailableColumnItemTemplate(
  item: IEmployeesReportColumn
) {
  return (
    <div>
      {item.name}({item.fieldName})
    </div>
  );
}
